import React, { useEffect, useRef, useState } from "react";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CustomeStyle } from "../../Css/CustomeStyle";
import Footer from "../../Fotter";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAllSubCategory,
  GetSubCategory,
} from "../../redux/slices/GetSubCategorySlice";
import { GetCategory } from "../../redux/slices/GetCategorySlice";
import { toast } from "react-toastify";
import { viewCartData } from "../../redux/slices/ViewCartSlice";
import { AddToCart } from "../../redux/slices/AddTocartSlice";
import { FiShoppingCart } from "react-icons/fi";
import {
  clearPriceFilterData,
  PriceFilter,
} from "../../redux/slices/PriceFilterSlice";
import {
  clearFilterProductData,
  FilterProduct,
} from "../../redux/slices/FilterProductSlice";
import { MdFilterList, MdArrowDropDown } from "react-icons/md";
import { GetCategorySubCate } from "../../redux/slices/GetCategorySubCateSlice";
import { AddWishlist } from "../../redux/slices/AddWishlistSlice";
import { AiOutlineArrowLeft } from "react-icons/ai";
import {
  clearCategoryData,
  GetCategoryData,
} from "../../redux/slices/GetCategoryDataSlice";
import ReactPaginate from "react-paginate";
import LoaderPage from "../Loader";

function ShowCategoryData() {
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const { name, activeCategory } = location.state || {};
  const [likedProducts, setLikedProducts] = useState(new Set());
  const [isSidebarVisible1, setIsSidebarVisible1] = useState(false);
  const { AllSubCategory, totalPages } = useSelector((state) => state.subCategory);
  const [availability, setAvailability] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const { FilterProductData, totalPagesFilterProduct } = useSelector((state) => state?.filterProduct);
  const [selectedRanges, setSelectedRanges] = useState([]);
  const { PriceFilterData } = useSelector((state) => state?.priceRange);
  const { AllCategory } = useSelector((state) => state?.category);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Default Sorting");
  const { SubCategory } = useSelector((state) => state.getCategorySub);
  const [activeSubCategory, setActiveSubCategory] = useState("");
  const [selectCategoryId, setSelectCategoryId] = useState("");
  const [showAll, setShowAll] = useState(false);
  const visibleCategories = showAll ? AllCategory : AllCategory?.slice(0, 5);
  const { CategoryData, totalPagesCategory } = useSelector((state) => state.categoryData);
  const [loading, setLoading] = useState(true);
  const { Cateid, Catenames } = useParams()
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(50);

  // useEffect(() => {
  //   dispatch(GetCategory());
  // }, [dispatch]);

  useEffect(() => {
    if (location.state?.page !== undefined) {
      setCurrentPage(location.state.page);
    }
  }, [location.state]);

  // useEffect(() => {
  //   const fetchSubcategories = async () => {
  //     setLoading(true);
  //     try {
  //       await dispatch(GetCategorySubCate(Cateid)).unwrap();
  //     } catch (error) {
  //       console.error("Error loading subcategories:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (Cateid) {
  //     fetchSubcategories();
  //   }
  // }, [Cateid, dispatch]);


  useEffect(() => {
    const fetchData = async () => {
      if (!activeSubCategory) {
        setLoading(true);
        try {
          dispatch(clearFilterProductData());
          dispatch(clearPriceFilterData())
          // await dispatch(GetCategoryData(Catenames)).unwrap();
          dispatch(
            GetCategoryData({
              name: Catenames,
              page: currentPage + 1,
              limit: 50,
            })
          );
          await dispatch(GetSubCategory(Catenames)).unwrap();
        } catch (error) {
          console.error("Error fetching category/subcategory:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, Catenames, currentPage]);


  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };

    dispatch(AddToCart(cartData))
      .then(() => {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  };

  useEffect(() => {
    const page = 0;
    setActiveSubCategory('')
    setCurrentPage(page)
    dispatch(clearPriceFilterData());
    dispatch(clearCategoryData());
    setSelectedBrand([]);
    setSelectedRanges([]);
    setLoading(true);
    if (selectedCategory) {
      dispatch(GetCategorySubCate(selectCategoryId?._id));
      // dispatch(FilterProduct({ name: "category", Catename: selectedCategory }))
      //   .unwrap()
      //   .finally(() => setLoading(false));
      dispatch(
        FilterProduct({
          name: "category",
          Catename: selectedCategory,
          page: page + 1,
          limit: 50,
        })
      );
      setLoading(false);
    } else if (Cateid || name?.id) {
      dispatch(GetCategorySubCate(Cateid ? Cateid : name?.id))
        .unwrap()
        .finally(() => setLoading(false));
    }
  }, [dispatch, selectedCategory]);

  useEffect(() => {
    const page = 0
    setCurrentPage(page)
    if (selectedRanges?.length > 0) {
      dispatch(
        PriceFilter({
          name: "category",
          price: "priceRange",
          priceRanges: selectedRanges,
          Catename: selectedCategory ? selectedCategory : Catenames,
          page: page + 1,
          limit: 50,
        })
      );
    }
  }, [selectedRanges, dispatch]);

  // useEffect(() => {
  //   setLoading(true);
  //   dispatch(clearCategoryData());
  //   if (selectedCategory || Catenames) {
  //     dispatch(
  //       PriceFilter({
  //         name: "category",
  //         price: "priceRange",
  //         priceRanges: selectedRanges,
  //         Catename: selectedCategory || Catenames,
  //       })
  //     )
  //       .unwrap()
  //       .finally(() => setLoading(false));
  //   }
  // }, [selectedRanges, dispatch]);

  const handleCheckboxChange = (range) => {
    setSelectedRanges((prev) => (prev === range ? "" : range));
  };

  const options = [
    "Default Sorting",
    "Sort by price: low to high",
    "Sort by price: high to low",
    "Sort by latest",
  ];

  const handleClearAll = () => {
    setLoading(true);
    dispatch(clearFilterProductData());
    dispatch(clearPriceFilterData());
    dispatch(GetCategorySubCate(selectCategoryId?._id ? selectCategoryId?._id : Cateid));
    setSelectedBrand([]);
    setActiveSubCategory("");
    setSelectedRanges([]);
    dispatch(GetCategoryData(selectedCategory));
    if (selectedCategory) {
      dispatch(FilterProduct({ name: "category", Catename: selectedCategory }))
        .unwrap()
        .finally(() => setLoading(false));
    } else {
      dispatch(GetSubCategory(activeCategory ? activeCategory : name))
        .unwrap()
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSidebarVisible1(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsSidebarVisible1(false);
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const _handleGo = async (name) => {
    const page = 0;
    setCurrentPage(page)
    setLoading(true);
    dispatch(clearPriceFilterData());
    dispatch(clearFilterProductData());
    dispatch(clearCategoryData());
    try {
      dispatch(
        GetSubCategory({
          name: name,
          page: page + 1,
          limit: 50,
        })
      ).unwrap()
      setActiveSubCategory(name);
    } catch (error) {
      console.error("Error fetching subcategory:", error);
    } finally {
      setLoading(false);
    }
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const ProductCard = ({
    item,
    likedProducts,
    toggleLike,
    handleAddToCart,
    CustomeStyle,
  }) => {
    return (
      <div className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 sm:px-4 sm:py-2 px-3 py-2">
        <img
          loading="lazy"
          src={item?.images?.productimage1}
          alt={item?.images?.itemimage1 || item.name}
          className="w-full h-28 sm:h-40 object-contain rounded-x bg-light"
        />
        <button
          className="like-btn absolute top-2 left-2"
          onClick={() => toggleLike(item._id)}
        >
          {likedProducts.has(item._id) ? (
            <FaHeart size="24px" className="text-red-500 sm:text-lg text-xs" />
          ) : (
            <FaRegHeart
              size="24px"
              className="text-gray-400 sm:text-lg md:text-xs"
            />
          )}
        </button>

        {item?.outOfStock ? <span className=" absolute bg-gray-200 top-2 right-2  p-1  text-red-500 text-bold text-gray-400 sm:ml-20 ml-0">
          Out of stock
        </span> :
          <button
            onClick={() => handleAddToCart(item)}
            className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
          >
            <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
          </button>
        }

        <Link
          to={`/shop/${item?.category ? generateSlug(item.category) : "-"}/${item?.subcategory ? generateSlug(item.subcategory) : "-"
            }/${item?.title ? generateSlug(item.title) : "-"}`}
          state={{ item }}
          className="block w-full hover:scale-105 hover:-translate-y-1"
        >
          <div className="mt-3">
            {item.name && (
              <h2 className="sm:text-xl text-xs text-black">{item.name}</h2>
            )}
            <h2
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              className={CustomeStyle?.title || "font-bold"}
            >
              {item.title}
            </h2>
            <div>
              {/* <span className={CustomeStyle?.description}>
                {item.description}
              </span> */}
            </div>
            <div className="mt-2 flex justify-between items-center me-2">
              <div className={`${CustomeStyle?.row} space-x-1`}>
                <span className={CustomeStyle?.text}>₹{item.salePrice}</span>
                <span className="line-through text-gray-500 text-sm">
                  ₹{item.regularPrice}
                </span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  };

  const NoProductFound = () => (
    <div className="flex justify-center items-center h-[200px] w-full sm:ms-96 ms-20">
      <p className="text-center text-lg font-semibold">No Product Found</p>
    </div>
  );

  const getProductsToRender = () => {
    if (loading) return [];

    if (PriceFilterData?.products) {
      return PriceFilterData.products.length > 0
        ? PriceFilterData.products
        : [];
    }
    if (
      (selectedBrand || selectedCategory) &&
      FilterProductData?.products?.length === 0
    ) {
      return [];
    }

    if (FilterProductData?.products?.length > 0) {
      return FilterProductData.products;
    }

    return CategoryData?.products?.length > 0
      ? CategoryData.products
      : AllSubCategory?.products?.length > 0
        ? AllSubCategory.products
        : [];
  };

  const productsToRender = getProductsToRender();
  const currentItems = productsToRender;
  const pageCount = Math.ceil(productsToRender.length / itemsPerPage);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const categoryTitle = selectCategoryId?.name || Catenames;

  const _handleCategoryClick = (category) => {
    dispatch(clearCategoryData())
    if (category?.subcategories?.length === 0) {
      setShowModal(true);
    }
    else {
      setSelectCategoryId(category);
      setSelectedCategory(category?.name);
    }
  }

  const _handlePaginationCall = (name, selected) => {
    dispatch(clearPriceFilterData());
    dispatch(clearFilterProductData());

    dispatch(
      GetSubCategory({
        name: name,
        page: selected + 1,
        limit: 50,
      })
    ).unwrap()
    setActiveSubCategory(name);
  };

  const _handleFilterData = (categoryName, selected) => {
    dispatch(clearAllSubCategory())
    dispatch(clearCategoryData())
    setActiveSubCategory('')
    const page = selected || 0;
    setCurrentPage(page)
    dispatch(
      FilterProduct({
        name: "category",
        Catename: categoryName,
        page: page + 1,
        limit: 50,
      })
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 ">
      <div className="flex items-center sm:px-14 sm:p-3 p-1 px-5 ">
        <button
          onClick={() => navigate(-1)}
          className="mr-2 bg-gray-200 px-2 py-2  rounded-full items-center  flex"
        >
          <AiOutlineArrowLeft className="text-lg mr-1" />
        </button>

        <h2 className="text-xl font-bold">
          {categoryTitle}
        </h2>
      </div>

      {SubCategory?.length > 0 && (
        <div className="flex justify-center w-full overflow-hidden">
          <div className="overflow-x-auto  flex sm:w-[90%] w-[90%] mx-auto sm:gap-6 gap-2 bg-gray-100 p-3 rounded-md">
            {SubCategory.map((subcategory, index) => {
              const isActive = activeSubCategory === subcategory.name;
              return (
                <div
                  key={index}
                  onClick={() => _handleGo(subcategory.name)}
                  className={`relative flex flex-col items-center cursor-pointer p-2 rounded-lg transition-colors duration-200 ${isActive ? "bg-blue-200" : "hover:bg-gray-200"
                    }`}
                >
                  <img
                    loading="lazy"
                    src={subcategory.image}
                    alt={subcategory.name}
                    className="w-12 h-12 rounded-full object-cover mb-2 border border-gray-300"
                  />
                  <p className="text-center font-medium text-gray-700 w-20 line-clamp-2 ">
                    {subcategory.name}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {activeSubCategory &&
        <h2 className="text-xl font-bold  sm:px-20  p-0 px-6  mt-4">
          {activeSubCategory ? activeSubCategory : ""}
        </h2>
      }
      <div className="mx-[5%] md:hidden  z-50 mt-[3%] bg-gray-200 flex flex-row justify-between px-2 items-center rounded">
        <button
          className="px-4 py-2  flex flex-row gap-1"
          onClick={() => {
            setIsSidebarVisible(!isSidebarVisible);
            setIsSidebarVisible1(false);
          }}
        >
          <MdFilterList size={24} className="text-gray-700" />
          <div className="text-gray-700 font-bold">Filter</div>
        </button>
        <div className="relative inline-block text-left ">
          <button
            className="px-4 py-2 m-2 flex flex-row bg-white rounded-2xl border border-gray-300 shadow-sm"
            onClick={() => setIsSidebarVisible1(!isSidebarVisible1)}
          >
            <div className="text-gray-700 font-bold truncate">
              {selectedOption}
            </div>
            <MdArrowDropDown className="text-gray-500 ml-2" size={24} />
          </button>

          {isSidebarVisible1 && (
            <div className="z-10 absolute mt-2 bg-white rounded-lg shadow-lg border border-gray-200 w-60">
              {options.map((option, index) => (
                <div
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className="px-4 py-2 text-black hover:bg-gray-100 cursor-pointer"
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="w-[90%] mx-auto flex flex-col md:flex-row gap-8 justify-center  mb-[3%] sm:mt-5 mt-1">
        <div className="relative">
          {isSidebarVisible && (
            <div
              className="fixed inset-0 bg-black opacity-50 z-30"
              onClick={() => setIsSidebarVisible(false)}
            ></div>
          )}
          <aside
            className={`w-3/5 md:w-full lg:w-full bg-white p-6 shadow-lg transition-all duration-300  ${isSidebarVisible
              ? "fixed top-0 left-0 z-40 h-full overflow-y-auto"
              : "hidden md:block"
              } md:sticky md:top-0 md:h-screen md:overflow-y-auto md:max-h-screen`}
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            <button
              className="absolute top-2 right-2 text-white bg-red-600 rounded-full px-3 py-1 lg:hidden"
              onClick={() => setIsSidebarVisible(false)}
            >
              X
            </button>

            <h3 className="text-black font-bold text-xl sm:text-1xl md:text-4xl lg:text-1xl">
              Filters
            </h3>
            <button
              className="text-blue-600 mb-6 hover:text-blue-800 mt-3"
              onClick={handleClearAll}
            >
              Clear All
            </button>
            <div>
              <h4 className="text-2xl font-semibold text-black">CATEGORIES</h4>
              <ul className="list-none mt-4">
                {visibleCategories?.map((category, index) => (
                  <li
                    key={index}
                    className={`cursor-pointer text-black mb-3 text-1xl hover:text-blue-600 ${selectedCategory === category?.name
                      ? "font-bold text-blue-600"
                      : ""
                      }`}
                    // onClick={() => setSelectedCategory(category?.name)}
                    onClick={() => {
                      _handleCategoryClick(category)
                    }}
                  >
                    {category?.name}
                  </li>
                ))}
              </ul>
              {AllCategory?.length > 5 && (
                <button
                  className="mt-2 text-blue-600 font-bold cursor-pointer"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View All Categories"}
                </button>
              )}
            </div>

            <div className="mt-6 mb-3">
              <h4 className="text-2xl font-semibold text-black">
                AVAILABILITY
              </h4>
              <div className="flex items-center mt-2">
                <input
                  type="checkbox"
                  checked={availability}
                  onChange={() => setAvailability(!availability)}
                  className="mr-2"
                />
                <label className="text-sm text-black">
                  Include Out of Stock
                </label>
              </div>
            </div>

            <h3 className="text-xl font-medium mb-2">Price Range:</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="100-1000"
                  checked={selectedRanges === "100-10000"}
                  onChange={() => handleCheckboxChange("100-10000")}
                  className="form-checkbox text-indigo-600"
                />
                <label htmlFor="100-1000" className="text-md">
                  100 - 10K
                </label>
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="10000-20000"
                  checked={selectedRanges === "10000-20000"}
                  onChange={() => handleCheckboxChange("10000-20000")}
                  className="form-checkbox text-indigo-600"
                />
                <label htmlFor="10000-20000" className="text-md">
                  10K - 20K
                </label>
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="20000-30000"
                  checked={selectedRanges === "20000-30000"}
                  onChange={() => handleCheckboxChange("20000-30000")}
                  className="form-checkbox text-indigo-600"
                />
                <label htmlFor="20000-30000" className="text-md">
                  20K - 30K
                </label>
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="30000-40000"
                  checked={selectedRanges === "30000-40000"}
                  onChange={() => handleCheckboxChange("30000-40000")}
                  className="form-checkbox text-indigo-600"
                />
                <label htmlFor="30000-40000" className="text-md">
                  30K - 40K
                </label>
              </div>
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="40000-60000"
                  checked={selectedRanges === "40000-60000"}
                  onChange={() => handleCheckboxChange("40000-60000")}
                  className="form-checkbox text-indigo-600"
                />
                <label htmlFor="30000-60000" className="text-md">
                  40K - 60K
                </label>
              </div>
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="60000-100000"
                  checked={selectedRanges === "60000-100000"}
                  onChange={() => handleCheckboxChange("60000-100000")}
                  className="form-checkbox text-indigo-600"
                />
                <label htmlFor="60000-100000" className="text-md">
                  60K - 1L
                </label>
              </div>
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="100000-200000"
                  checked={selectedRanges === "100000-200000"}
                  onChange={() => handleCheckboxChange("100000-200000")}
                  className="form-checkbox text-indigo-600"
                />
                <label htmlFor="100000-200000" className="text-md">
                  1L - 2L
                </label>
              </div>
            </div>
          </aside>
        </div>
        <div className="w-full sm:w-[95%] md:w-[100%] mt-0 ">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-1 lg:gap-3">
            {loading ? (
              <LoaderPage />
            ) : currentItems.length > 0 ? (
              currentItems.map((item) => (
                <ProductCard
                  key={item._id}
                  item={item}
                  likedProducts={likedProducts}
                  toggleLike={toggleLike}
                  handleAddToCart={handleAddToCart}
                  CustomeStyle={CustomeStyle}
                />
              ))
            ) : (
              <NoProductFound />
            )}
          </div>
        </div>
      </div>

      <div className="w-full flex justify-center mt-6 mb-5">
        <div className="w-full max-w-[90%] sm:max-w-[70%] md:max-w-[60%] lg:max-w-[50%] overflow-auto">
          <ReactPaginate
            previousLabel={
              <span className="px-1 py-1 text-xs sm:text-sm font-medium whitespace-nowrap">
                Prev
              </span>
            }
            nextLabel={
              <span className="px-1 py-1 text-xs sm:text-sm font-medium whitespace-nowrap">
                Next
              </span>
            }
            breakLabel={"..."}
            pageCount={
              CategoryData.products?.length > 0
                ? totalPagesCategory
                : FilterProductData?.products?.length > 0
                  ? totalPagesFilterProduct
                  : AllSubCategory?.products?.length > 0
                    ? totalPages
                    : 0
            }
            marginPagesDisplayed={1}
            pageRangeDisplayed={window.innerWidth > 768 ? 5 : 3}
            // onPageChange={handlePageClick}
            onPageChange={({ selected }) => {
              setCurrentPage(selected);
              if (activeSubCategory) {
                _handlePaginationCall(activeSubCategory, selected)
              }
              if (selectedCategory && !activeSubCategory) {
                _handleFilterData(selectedCategory, selected)
              }
            }}
            containerClassName="flex items-center justify-center gap-2 px-2 py-2 overflow-auto no-scrollbar"
            pageClassName="rounded-md border border-black hover:bg-blue-500 hover:text-white transition duration-300"
            pageLinkClassName="w-full h-full px-2 py-1 text-xs sm:text-sm flex items-center justify-center cursor-pointer"
            activeClassName="bg-blue-500 text-white border-blue-600"
            previousClassName="px-2 py-1 text-xs sm:text-sm border border-gray-200 rounded-md bg-gray-100 hover:bg-blue-500 hover:text-white transition duration-300 cursor-pointer"
            nextClassName="px-2 py-1 text-xs sm:text-sm border border-gray-200 rounded-md bg-gray-100 hover:bg-blue-500 hover:text-white transition duration-300 cursor-pointer"
            breakClassName="px-2 py-1 text-gray-500"
            disabledClassName="opacity-50 cursor-not-allowed"
            forcePage={currentPage}
          />
        </div>
      </div>

      <Footer />

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 w-[300px] text-center shadow-lg">
            <h2 className="text-xl font-bold mb-2">Coming Soon</h2>
            <p className="text-gray-600 mb-4">Products for this category will be available soon</p>
            <button
              onClick={() => setShowModal(false)}
              className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ShowCategoryData;
